/**
 * Spacing Design Tokens
 * Scale-based spacing system for consistent layouts
 * Based on DESIGN_TOKENS.md specification
 */

export const spacing = {
  // Base spacing scale (4px-based)
  0: '0',
  1: '4px',
  2: '8px',
  3: '12px',
  4: '16px',
  6: '24px',
  8: '32px',
  12: '48px',
  16: '64px',
  20: '80px',
  24: '96px',

  // Semantic spacing (inset)
  inset: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },

  // Semantic spacing (stack - vertical gap)
  stack: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },

  // Semantic spacing (inline - horizontal gap)
  inline: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },

  // Grid gaps
  gap: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },
};

export type Spacing = typeof spacing;
export type SpacingValue = keyof typeof spacing | (typeof spacing)[keyof typeof spacing];
